import HttpRepository from './httpRepository'

export default class LotteryRepository extends HttpRepository {
  fetch(liveId) {
    return this.get(`/v1/serial/lottery/${liveId}`)
  }

  lottery(code, liveId) {
    const params = new URLSearchParams()
    params.append('live_id', liveId)
    return this.put(`/v1/serial/lottery/${code}`, params)
  }

  kyc(code) {
    const params = new URLSearchParams()
    params.append('code', code)
    return this.post('/v1/lottery/realkyc', params)
  }
}
